"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Route = void 0;
var Route;
(function (Route) {
    Route["Base"] = "/user-onboarding";
    /* User Onboarding children */
    Route["ProfileSurvey"] = "profile-survey";
    Route["SelectRegion"] = "select-region";
    Route["PrivacyPolicy"] = "privacy-policy";
    Route["RedeemCode"] = "redeem-code";
    Route["PushNotifications"] = "push-notifications";
    Route["MissingProfile"] = "missing-profile";
    Route["SubscriptionsSheet"] = "subscriptions-sheet";
    /* Survey children */
    Route["SelectUserType"] = "select-user-type";
    Route["SelectSpeciality"] = "select-speciality";
    Route["SelectGraduationDate"] = "select-graduation-date";
    Route["ProfileComplete"] = "profile-complete";
    /* Speciality children */
    Route["Student"] = "student";
    Route["Academic"] = "academic";
    Route["Enthusiast"] = "enthusiast";
    Route["HealthcareProvider"] = "healthcare-provider";
    Route["AlternativePractitioner"] = "alternative-practitioner";
})(Route || (exports.Route = Route = {}));
